import BX from 'BX';

/**
 * Adds product to cart
 * @param {Number} productId
 * @param {Number} quantity
 * @returns {BX.Promise}
 */
export function ajaxAddToBasket(productId, quantity) {
	return BX.ajax.runAction('local:site.basketajax.add', {
		data: {
			productId,
			quantity,
			customPrice: {
				code: 'RETAIL',
				currency: 'EUR'
			},
			basketLineParams: {
				PATH_TO_BASKET: '/basket/',
				PATH_TO_PERSONAL: '/personal/',
			}
		},
	});
}
